import { z } from 'zod';

// POC: defaults to the deployed text-overrides Lambda (stack text-overrides-poc, dokka-dev); set
// REACT_APP_TEXT_OVERRIDES_API_URL=http://localhost:4011 to use the local service.
// Only REACT_APP_* variables reach the bundle (webpack DefinePlugin). An empty value counts as unset.
const TextOverridesEnvSchema = z.object({
  REACT_APP_TEXT_OVERRIDES_API_URL: z.preprocess((v) => (v === '' ? undefined : v), z.url().default('https://um3vq7067a.execute-api.eu-west-1.amazonaws.com')),
});

/** Base URL of the text-overrides service, without a trailing slash. Validated when the module loads. */
export const textOverridesApiUrl = TextOverridesEnvSchema.parse({
  REACT_APP_TEXT_OVERRIDES_API_URL: process.env.REACT_APP_TEXT_OVERRIDES_API_URL,
}).REACT_APP_TEXT_OVERRIDES_API_URL.replace(/\/+$/, '');
